import React from "react";
import Button from "@/bit/components/components.button";
import Carousel from "@/bit/components/components.carousel";

// Convertir a minúsculas, reemplazar espacios por guiones bajos y eliminar caracteres no válidos
function normalizeCategory(str) {
  try {
    const normalizeStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return normalizeStr
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  } catch (error) {
    return "";
  }
}

const FilterButtons = ({
  buttonList,
  selectedCategory,
  setselectedCategory,
  cmsHandler,
}) => {
  if (!Array.isArray(buttonList) || buttonList.length <= 0) {
    return null;
  }

  return (
    <div className="container filter-cards--row">
      <Carousel
        arrowWidth={0}
        arrowRadius={0}
        pointRadius={0}
        slideSeparation={8}
        maxPointNum={0}
        pagination={false}
      >
        {buttonList.map((button, index) => {
          const { "cms-atom-button-1": buttonProps } = button;
          const category = normalizeCategory(buttonProps?.label);
          return (
            <Button
              {...buttonProps}
              onClick={() => setselectedCategory(category)}
              type={
                category === selectedCategory ? "primary_reverse" : "collapsed"
              }
              className="filter-cards--row_button"
              key={`filter-cards--${index}`}
              cmsHandler={cmsHandler}
              taggingInfo={{
                componentName: "filter-cards",
                componentVariation: "all",
                componentContent: buttonProps?.label,
                componentProduct: buttonProps?.label,
                eventType: "click",
              }}
              cyData={`FilterCards-${index} Button`}
            />
          );
        })}
      </Carousel>
      <style jsx>{`.filter-cards--row {
  align-items: center;
  margin-top: 0.5rem !important;
  :global(.button-type--collapsed) {
    border: solid 1px #dddddd !important;
  }
  :global(.buttonx) {
    position: relative !important;
  }
}
`}</style>
    </div>
  );
};

export default FilterButtons;
